import images from "./image-manifest.json";

export function optimizedSource(src) {
  return images[src]?.src || src;
}

export default function SiteImage({
  src,
  alt,
  loading = "lazy",
  sizes,
  ...props
}) {
  const image = images[src];
  return (
    <img
      decoding="async"
      loading={loading}
      {...(image
        ? {
            width: image.width,
            height: image.height,
            srcSet: image.srcSet,
            sizes: image.srcSet
              ? sizes ||
                (props.className?.includes("logo")
                  ? "220px"
                  : "(max-width: 700px) 92vw, 800px")
              : undefined,
          }
        : {})}
      {...props}
      src={image?.src || src}
      alt={alt}
    />
  );
}
